<template>
  <header class="topbar">
    <div class="topbar__content">
      <!-- <img class="topbar__logo" src="@/assets/images/vision-tv-white-logo.svg" alt="logo mnc play"> -->
      <!-- <img class="topbar__logo" src="@/assets/images/mnc-play-logo.svg" alt="logo mnc play"> -->
      <img class="topbar__logo" src="@/assets/images/mnclogo.png" alt="logo mnc play">
      <h2 style="color: #000;">Purchase Services</h2>
    </div>
  </header>
</template>

<script>
export default {
  
}
</script>